/// <reference path="Constants.js"/>
/// <reference path="Helpers.js"/>
/// <reference path="GeneralSettings.js" />

(function (sb) {
	sb.ReferenceDataFiltering = (sb.ReferenceDataFiltering || {});

	var NO_SELECTION_ID = "0-0";
	var availableRefDataSetsType;
	var previousSettingsStr;
	var ajaxCallId = 0;

	function setAvailableRefDataSetsType(type) { availableRefDataSetsType = type; }

	function showHideRefDataSets(forceUpdate) {
		if (!isEnabled())
			return Promise.resolve();

		return getAvailableSets(forceUpdate);
	}

	function selectionsChanged(selectedSettings) {
		var currentSettingsStr = JSON.stringify(selectedSettings);
		if (currentSettingsStr === previousSettingsStr)
			return false;

		previousSettingsStr = currentSettingsStr;
		return true;
	}

	function getSelectedSettings() {
		var settingsToUse = [];

		if (Storyboard.Constants.AvailableRefDataSetsType.usesHFilter(availableRefDataSetsType)) {
			var selectedHFilters = Storyboard.HFilterLayout.getSelectedIds("#hfilterTree");

			if (selectedHFilters && selectedHFilters.length > 0) {
				settingsToUse.push({
					SettingType: 6,
					SelectedSettings: selectedHFilters.toString()
				});
			}
		}

		if (Storyboard.Constants.AvailableRefDataSetsType.usesFilter(availableRefDataSetsType)) {
			var filterSetting = { SettingType: 5 };

			$('#pnlSettingsPanel [id^="lbSetting_5"]').each(function () {
				var $select = $(this);

				var selections = filterSetting.SelectedSettings && filterSetting.SelectedSettings.length ? (filterSetting.SelectedSettings + ',') : '';

				$select.multiselect('getChecked').each(function (idx, elem) {
					var id = $(elem).val();
					if (id != NO_SELECTION_ID)
						selections += id + ',';
				});

				if (selections.length == 0 && !filterSetting.SelectedSettings)
					filterSetting.SelectedSettings = '';
				else
					filterSetting.SelectedSettings = selections.replace(/,$/g, '');
			});

			if (filterSetting.SelectedSettings)
				settingsToUse.push(filterSetting);
		}

		return settingsToUse;
	}

	function setRefDataSetsVisibility(visibleSetsIds, defaultSelection) {
		var $dropdown = $('#pnlSettingsPanel #lbSetting_9');
		$dropdown.find('option').each(function (idx, option) {
			var $option = $(option);

			var isVisible = visibleSetsIds.indexOf($option.val()) >= 0;
			if (!isVisible && $option.val() != NO_SELECTION_ID) {
				$(option).attr('hidden', 'hidden');
			} else {
				$option.removeAttr('hidden');
			}
		});

		if (defaultSelection)
			$dropdown.val(defaultSelection);

		if ($dropdown.find('option:selected[hidden]').length > 0 || $dropdown.find('option:selected').length == 0) {
			if ($dropdown.find('option[value="' + NO_SELECTION_ID + '"]').length > 0)
				$dropdown.val(NO_SELECTION_ID);
			else
				$dropdown.val($dropdown.find('option:not([disabled]):not([hidden])').first().val() || []);
		}

		$dropdown.multiselect('refresh');
	}

	function getAvailableSets(forceUpdate) {
		var selectedSettings = getSelectedSettings();
		if (!forceUpdate && !selectionsChanged(selectedSettings))
			return Promise.resolve();

		ajaxCallId++;
		var currentAjaxCallId = ajaxCallId;

		var promise = Helpers.perfJSonCall({
			method: 'GetAvailableRefDataSets',
			message: locale.get('Loading Reference Data filters'),
			data: { settings: selectedSettings },
			service: 'GeneralSettings',
			fixCasing: true
		});

		promise.done(function (response) {
			setRefDataSetsVisibility(response.d.availableDisplayIds, response.d.defaultSelection);
			if (currentAjaxCallId !== ajaxCallId)
				return;
			$(document).trigger('DAPI.referenceDataSetsLoaded');
		});

		return promise;
	}

	function isEnabled() {
		var useHFilter = Storyboard.Constants.AvailableRefDataSetsType.usesHFilter(availableRefDataSetsType) && Storyboard.GeneralSettings.hasHFilter();
		var useFilter = Storyboard.Constants.AvailableRefDataSetsType.usesFilter(availableRefDataSetsType) && Storyboard.GeneralSettings.hasFilter();
		return ProjectHasRefData && availableRefDataSetsType != Storyboard.Constants.AvailableRefDataSetsType.All &&
			$('#pnlSettingsPanel #lbSetting_9').length > 0 && (useHFilter || useFilter);
	}

	sb.ReferenceDataFiltering.isEnabled = isEnabled;
	sb.ReferenceDataFiltering.setAvailableRefDataSetsType = setAvailableRefDataSetsType;
	sb.ReferenceDataFiltering.showHideRefDataSets = showHideRefDataSets;
}(window.Storyboard = (window.Storyboard || {})));